const BASE_URL = 'https://graph.facebook.com/v21.0/';
const PAGES_GENERAL = `${BASE_URL}me/accounts?fields=id,name,access_token,instagram_business_account,category,about,link,followers_count&access_token=`;
const INSTAGRAM_PROFILE_PARAMS = '?fields=name,username,media_count,followers_count&access_token=';
const INSIGHTS_PATH = '/insights';
const REACH_PARAMS = '?metric=reach&metric_type=time_series&period=days_28&access_token=';
const OTHER_DAILY_INSIGHTS_PARAMS = '?metric=views,accounts_engaged,follows_and_unfollows&metric_type=total_value&period=day&access_token=';
const POST_INSIGHTS_PARAMS = '?metric=views,reach,saved&access_token=';
const ALL_MEDIA_PATH = '/media';
const ALL_MEDIA_PARAMS = '?fields=id,caption,like_count,media_url,permalink&access_token=';

class StoryInsightsApi {
  static async getPages(token) {
    try {
      const fetchResponse = await fetch(`${PAGES_GENERAL}${token}`);
      const data = await fetchResponse.json();

      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getInstagramProfile(profileId, token) {
    try {
      const fetchResponse = await fetch(`${BASE_URL}${profileId}${INSTAGRAM_PROFILE_PARAMS}${token}`);
      const data = await fetchResponse.json();

      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getInstagramReach(profileId, token) {
    try {
      const fetchResponse = await fetch(`${BASE_URL}${profileId}${INSIGHTS_PATH}${REACH_PARAMS}${token}`);
      const data = await fetchResponse.json();

      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getInstagramOtherInsights(profileId, token) {
    try {
      const fetchResponse = await fetch(`${BASE_URL}${profileId}${INSIGHTS_PATH}${OTHER_DAILY_INSIGHTS_PARAMS}${token}`);
      const data = await fetchResponse.json();

      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getInstagramPosts(profileId, token) {
    try {
      const fetchResponse = await fetch(`${BASE_URL}${profileId}${ALL_MEDIA_PATH}${ALL_MEDIA_PARAMS}${token}`);
      const data = await fetchResponse.json();

      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getInstagramPostInsights(postId, token) {
    try {
      const fetchResponse = await fetch(`${BASE_URL}${postId}${INSIGHTS_PATH}${POST_INSIGHTS_PARAMS}${token}`);
      const data = await fetchResponse.json();

      return data;
    } catch (error) {
      throw error;
    }
  }
}

export default StoryInsightsApi;
